import { Chip, SxProps, Theme } from '@mui/material';

import mixinSx from '@watershed/style/mixinSx';

export const kbdChipSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.grey05,
  color: (theme) => theme.palette.grey80,
  borderRadius: '4px',
  border: (theme) => `1px solid ${theme.palette.grey20}`,
  borderBottom: (theme) => `2px solid ${theme.palette.grey20}`,
  minWidth: 20,
};

/**
 * A styled Chip component for displaying keyboard shortcuts with proper semantic markup.
 * Uses the <kbd> element for accessibility and applies consistent keyboard shortcut styling.
 */
export default function KbdChip({
  label,
  sx,
  ariaHidden = false,
}: {
  label: string | number;
  sx?: SxProps<Theme>;
  ariaHidden?: boolean;
}) {
  return (
    <Chip
      label={label}
      size="small"
      component="kbd"
      aria-hidden={ariaHidden}
      sx={mixinSx(
        kbdChipSx,
        {
          '& .MuiChip-label': {
            fontFamily: (theme) => theme.typography.fontFamilyMonospace,
            fontSize: 12,
            fontWeight: (theme) => theme.typography.fontWeightRegular,
            padding: 0.5,
            textTransform: 'uppercase',
          },
        },
        sx
      )}
    />
  );
}
